export const state = () => ({
    comments: [],
})

export const mutations = {
    SET_COMMENTS(state, payload) {
        state.comments.push(payload)
    },
    ADD_COMMENT(state, payload) {
        state.comments.unshift(payload)
    },
    FLUSH_COMMENTS(state) {
        state.comments = []
    }
}

export const actions = {
    setComments({ commit }, comments) {
        commit('SET_COMMENTS', comments)
    },
    addComment({ commit }, comments) {
        commit('ADD_COMMENT', comments)
    },
    flushComments({ commit }) {
        commit('FLUSH_COMMENTS')
    }
}